module.exports = __webpack_public_path__ + "img/dry.9c787547.svg";